export const ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  HOME: '/',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',
  IMAGE: 'image',

  /* Orders */
  ORDER_LIST: '/orders/list',
  ORDERS_ITEM_DETAIL: '/orders/item/:id',
  ONLINE_ORDER_DETAIL_PAGE: '/orders/online/:id',
  OFFLINE_ORDER_DETAIL_PAGE: '/orders/offline/:id',
  REFUNDED_ORDER_DETAIL_PAGE: '/orders/refunds/:id',
  REWARDS_ORDER_DETAIL_PAGE: '/orders/rewards/:id',

  /* Delivery */
  DELIVERY_OVERVIEW: '/delivery/overview',
  DELIVERY_ROUTES: '/delivery/routes',
  DELIVERY_HOLIDAYS: '/delivery/holidays',
  DELIVERY_EVENTS: '/delivery/events',
  DELIVERY_MOA: '/delivery/moa',
  DELIVERY_MOV: '/delivery/mov',
}
